import React from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Flex, Text } from 'core/components';
import { AI_DISCLAIMER_SHORT } from 'app/components/journeys/constants';
import KaizenChatSession from './KaizenChatSession';
import KaizenInput from './KaizenInput';
import KaizenEmptyState from './KaizenEmptyState';
import KaizenToolResultPanel from './KaizenToolResultPanel';
import KaizenSidebar from './KaizenSidebar';
import ResizablePanels from './ResizablePanels';
import { FancyInput, KaizenScrollArea } from './KaizenChatSession.styles';

const KaizenDesktopLayout = inject('$journeys')(
  observer(
    ({
      $journeys,
      isSidebarCollapsed,
      selectedToolResults,
      isScrolledToBottom,
      isExistingChatLoading,
      inputRef,
      scrollAreaRef,
      onScroll,
      onScrollToBottom,
      onSelectToolResult,
      onCloseToolResult,
      onCloseToolResults,
      onCreateJourney,
      onSelectJourneyAfterCreation,
      onSelectJourney
    }) => {
      const containsQueries =
        $journeys.chatSessionCollection?.selected?.id && $journeys.chatSessionCollection?.selected?.get('messages');
      const selectedJourney = $journeys.chatSessionCollection?.selected;

      return (
        <Flex height="100%" width="100%">
          <ResizablePanels
            showRightPanel={selectedToolResults?.length > 0}
            leftMinWidth={350}
            rightMinWidth={400}
            leftPanel={
              <Flex flexDirection="column" width="100%" bg="decks.background" height="calc(100vh - 100px)">
                <KaizenScrollArea ref={scrollAreaRef} onScroll={onScroll}>
                  {containsQueries ? (
                    <KaizenChatSession
                      key={$journeys.chatSessionCollection?.selected.id}
                      chatSessionModel={$journeys.chatSessionCollection?.selected}
                      scrollToBottom={onScrollToBottom}
                      isScrolledToBottom={isScrolledToBottom}
                      onSelectToolResult={onSelectToolResult}
                      isExistingChatLoading={isExistingChatLoading}
                    />
                  ) : (
                    <KaizenEmptyState
                      inputRef={inputRef}
                      selectedJourney={selectedJourney}
                      placeholder="Ask anything about your network"
                      createJourney={onCreateJourney}
                      scrollToBottom={onScrollToBottom}
                      selectJourneyAfterCreation={onSelectJourneyAfterCreation}
                    />
                  )}
                </KaizenScrollArea>
                {containsQueries && (
                  <FancyInput>
                    <KaizenInput
                      scrollToBottom={onScrollToBottom}
                      inputRef={inputRef}
                      key={selectedJourney?.id || 'new-journey-input'}
                      placeholder="Ask any question about your network"
                      chatSessionModel={$journeys.chatSessionCollection?.selected}
                      createJourney={onCreateJourney}
                      selectJourneyAfterCreation={onSelectJourneyAfterCreation}
                    />
                    <Flex alignItems="center" gap={2} role="contentinfo">
                      {containsQueries && (
                        <Button icon="arrow-down" onClick={onScrollToBottom} small minimal>
                          <Text muted>Scroll to Bottom</Text>
                        </Button>
                      )}
                      <Text small muted>
                        {AI_DISCLAIMER_SHORT}
                      </Text>
                    </Flex>
                  </FancyInput>
                )}
              </Flex>
            }
            rightPanel={
              selectedToolResults?.length > 0 && (
                <KaizenToolResultPanel
                  tools={selectedToolResults}
                  onCloseToolResult={onCloseToolResult}
                  onClose={onCloseToolResults}
                />
              )
            }
          />

          {!isSidebarCollapsed && <KaizenSidebar onSelectJourney={onSelectJourney} />}
        </Flex>
      );
    }
  )
);

export default KaizenDesktopLayout;
